// Lectures.js
import React from 'react';
import { Typography, Grid, Paper } from '@mui/material';

const Lectures = () => {
  const videos = [
    {
      videoUrl: 'https://www.youtube.com/embed/10IgfM7t2tA',
    },
    {
        videoUrl: 'https://www.youtube.com/embed/0J411n91c9Q',
      }
      ,
    {
        videoUrl: 'https://www.youtube.com/embed/jtL650KaUFI',
      },
    {
        videoUrl: 'https://www.youtube.com/embed/cjGFOxmpAx0',
      } ,
      {
          videoUrl: 'https://www.youtube.com/embed/rCljUSeSJm4',
        }
        ,
        {
            videoUrl: 'https://www.youtube.com/embed/Cs_mZsWSH58',
          }
          
    
      
    // Add more videos as needed
  ];

  return (
    <Grid container spacing={2} sx={{display:'flex',flexDirection:'column', justifyContent:'center',alignItems:'center'}} >
      {videos.map((video, index) => (
        <Grid  sx={{width:'95%',marginLeft:'10px',marginRight:'10px'}} key={index}>
          <Paper elevation={3} style={{marginTop:'50px',marginLeft:'10px',marginRight:'10px', padding: '20px', textAlign: 'center' , backgroundColor:'goldenrod' }}>
            <Typography variant="h6">{video.title}</Typography>
            <iframe
              width="100%"
              height="400"
              src={video.videoUrl}
              title={video.title}
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default Lectures;
